/**
 * Transforme un nom de pod K8s en label utilisateur lisible.
 *
 * Pattern NubieCloud : `app-<name>-<8hex slug>-<suite variable>`
 * Ex :
 *   app-clubapi-9b57dc43-nubi-code-app-658495b56-vfb5c   -> instance-clubapi
 *   app-zari-backend-postgres-b075e3a5-nubi-code-app-... -> instance-zari-backend-postgres
 *   app-zari-redis-95073a71-0                            -> instance-zari-redis
 *
 * Fallback : renvoie le nom brut si le pattern n'est pas reconnu.
 */
export function formatPodName(podName: string): string {
  if (!podName) return podName;
  const match = podName.match(/^app-(.+?)-[0-9a-f]{8}-/);
  return match ? `instance-${match[1]}` : podName;
}
